module.exports = __webpack_public_path__ + "static/media/tool.ef69a4ba.jpg";